var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLearningIcon = function SvgLearningIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.9999H7.20713L12.3533 7.85372L12.3536 7.85345L12.3539 7.85314L13.9999 6.20706C14.0928 6.11421 14.1665 6.00397 14.2168 5.88264C14.267 5.76131 14.2929 5.63127 14.2929 5.49995C14.2929 5.36862 14.267 5.23857 14.2168 5.11724C14.1665 4.99591 14.0929 4.88567 14 4.79281L11.2071 1.99984C11.0194 1.81263 10.7651 1.70751 10.5 1.70752C10.2348 1.70753 9.98055 1.81268 9.79285 1.9999L2.29285 9.49993C2.19574 9.59703 2.11974 9.71313 2.0696 9.84097C2.06445 9.85345 2.06012 9.86614 2.05603 9.87893C2.01915 9.98439 2.00021 10.0953 2 10.207V12.9999C2.0003 13.265 2.10576 13.5192 2.29323 13.7067C2.4807 13.8941 2.73488 13.9996 3 13.9999H13.5C13.6326 13.9999 13.7598 13.9472 13.8536 13.8535C13.9473 13.7597 14 13.6325 14 13.4999C14 13.3673 13.9473 13.2401 13.8536 13.1463C13.7598 13.0526 13.6326 12.9999 13.5 12.9999ZM10.5 2.70699L13.2928 5.4999L12 6.79275L9.20713 3.9999L10.5 2.70699Z",
    fill: "#EAE4FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLearningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LearningIcon.c5ed64c4.svg";
export { ForwardRef as ReactComponent };